import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { shareReplay, startWith, Subject, switchMap, tap } from "rxjs";
import { Instructor } from "../booking/detail/booking-detail.component";

@Injectable({ providedIn: "root" })
export class InstructorService {
  private readonly base = window.location.port === "4200" ? "/api" : "/api"; // dev et prod via /api

  private refresh$ = new Subject<void>();

  // flux public de la liste
  readonly aircrafts$ = this.refresh$.pipe(
    startWith(void 0), // premier chargement
    switchMap(() => this.http.get<Instructor[]>(`${this.base}/instructor`)),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(private http: HttpClient) {}

  getInstructors() {
    return this.http.get<any[]>(`${this.base}/instructor?filterByFavorites=1`);
  }
}
